module.exports = __webpack_public_path__ + "img/1562274099.e3b0ff28.jpg";